import React from 'react';
import Icon from '../AppIcon';

const TopTabs = ({ tabs, activeTab, onChange }) => {
  return (
    <div className="mb-6 md:mb-8 overflow-x-auto">
      <div className="flex items-center space-x-2 min-w-max">
        {(tabs || []).map((tab) => (
          <button
            key={tab?.id}
            type="button"
            onClick={() => onChange?.(tab?.id)}
            className={`flex items-center space-x-2 px-4 md:px-6 py-2 md:py-3 rounded-md transition-gaming ${
              activeTab === tab?.id
                ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span className="text-sm md:text-base font-medium whitespace-nowrap">{tab?.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TopTabs;
